import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DashboardService } from 'app/main/services/dashboard.service';

@Component({
  selector: 'app-cert-alert',
  templateUrl: './cert-alert.component.html',
  styleUrls: ['./cert-alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CertAlertComponent implements OnInit {

  @Output() selectEvent = new EventEmitter<{type: string, value: any}>();

  constructor(private _list: DashboardService) { }
  ngOnInit(): void {
  }
}
